import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import type { SVGProps } from 'react';
const SvgIpsVvThin = function (props: SVGProps<SVGSVGElement>) {
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill={`url(#${_id})`}
        fillRule="evenodd"
        d="M12.003 1.263c-5.921 0-10.727 4.806-10.727 10.727s4.806 10.726 10.727 10.726S22.729 17.91 22.729 11.99 17.923 1.263 12.003 1.263m4.767 16.464c-.965 2.137-2.346 3.454-3.348 4.189l.013-.002a10 10 0 0 0 1.012-.198 10 10 0 0 0 1.583-.543 10 10 0 0 0 1.8-1.025 10 10 0 0 0 .99-.809c-.226-.309-.837-1.016-2.05-1.612m-9.544.003c-1.195.593-1.803 1.295-2.036 1.614a10 10 0 0 0 5.382 2.571c-1.004-.735-2.383-2.05-3.346-4.185m4.427-.967c-1.591.035-2.829.314-3.779.683 1.156 2.548 2.931 3.841 3.779 4.342zm.7.001v5.021c.848-.506 2.615-1.802 3.769-4.341-.949-.366-2.184-.644-3.769-.68M1.982 12.34a10 10 0 0 0 2.706 6.504c.323-.422 1.016-1.158 2.267-1.768-.493-1.295-.828-2.859-.865-4.734zm15.93.008c-.04 1.87-.377 3.431-.87 4.725 1.266.612 1.962 1.351 2.28 1.766a10 10 0 0 0 2.701-6.489zm-11.121.012q.008.348.03.696a15 15 0 0 0 .163 1.414 13 13 0 0 0 .34 1.492 12 12 0 0 0 .275.821l.004.01c1.027-.398 2.354-.695 4.05-.73v-3.718l-4.862-.003zm10.42-.013-4.858-.002v3.718c1.69.037 3.015.333 4.04.729l.004-.011a12 12 0 0 0 .276-.82 13 13 0 0 0 .342-1.491 14 14 0 0 0 .165-1.413q.023-.348.031-.696zm2.088-7.232c-.329.426-1.024 1.154-2.264 1.756.5 1.304.842 2.882.877 4.777l4.111.002v-.016a10 10 0 0 0-.492-2.771 10 10 0 0 0-1.107-2.314 10 10 0 0 0-.714-.97 11 11 0 0 0-.409-.462zm-2.913 2.038c-1.023.396-2.345.691-4.033.726v3.766l4.859.002c-.036-1.783-.357-3.268-.826-4.494m-8.769.014a12 12 0 0 0-.282.835 13 13 0 0 0-.348 1.508 14 14 0 0 0-.164 1.413q-.024.358-.032.717v.002l4.862.003V7.879c-1.686-.036-3.007-.33-4.031-.723zm-2.921-2.04a10 10 0 0 0-2.714 6.513l4.109.002v-.002q.007-.373.032-.745.048-.76.173-1.511a14 14 0 0 1 .371-1.613q.135-.451.304-.892l.001-.003c-1.251-.602-1.949-1.329-2.276-1.749m7.657-2.934v4.986h.014a13 13 0 0 0 .522-.022c.559-.033 1.117-.1 1.666-.209a9.6 9.6 0 0 0 1.55-.443l.009-.004c-1.155-2.524-2.916-3.808-3.761-4.308m-.7 0c-.843.502-2.602 1.789-3.758 4.312.948.362 2.179.638 3.758.674zm-1.083-.128a10 10 0 0 0-2.581.735A10 10 0 0 0 6.2 3.814a10 10 0 0 0-.993.806l-.009.008c.241.323.856 1.013 2.047 1.595.965-2.119 2.337-3.428 3.335-4.16zm2.859-.001c.999.731 2.37 2.037 3.333 4.153 1.179-.581 1.79-1.271 2.034-1.6a10 10 0 0 0-5.367-2.553"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={1}
          x2={27.113}
          y1={23}
          y2={8.312}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#142279" />
          <stop offset={0.231} stopColor="#1939D4" />
          <stop offset={0.48} stopColor="#5D4DF8" />
          <stop offset={0.743} stopColor="#B459F9" />
          <stop offset={1} stopColor="#FE3B68" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgIpsVvThin;
